module.exports = __webpack_public_path__ + "static/media/Restated Master Deed and Bylaws.9b1c3632.pdf";